export default __webpack_public_path__ + "static/Empower-8d0616956f05e76adec88755fcc21d05.svg";